var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectsTabUnselectedMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "22px",
    viewBox: "0 0 34 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.000000, -380.000000)",
    fill: "#D7DBE4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Men\\xFA-izquierda-Dashboard-Men\\xFA-izquierda-JO",
    transform: "translate(-1.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Proyectos-Proyectos-unselected",
    transform: "translate(15.000000, 378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Proyectos-unselected",
    transform: "translate(18.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4318026,4 L9.5681974,4 C8.69499657,4 8,3.1 8,2 C8,0.9 8.712817,0 9.5681974,0 L32.4318026,0 C33.3050034,0 34,0.9 34,2 C34,3.1 33.3050034,4 32.4318026,4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4318026,22 L9.5681974,22 C8.69499657,22 8,21.1 8,20 C8,18.9 8.712817,18 9.5681974,18 L32.4318026,18 C33.3050034,18 34,18.9 34,20 C34,21.1 33.3050034,22 32.4318026,22 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4318026,13 L9.5681974,13 C8.69499657,13 8,12.1 8,11 C8,9.9 8.712817,9 9.5681974,9 L32.4318026,9 C33.3050034,9 34,9.9 34,11 C34,12.1 33.3050034,13 32.4318026,13 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 11,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 20,
    r: 2
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsTabUnselectedMobile);
export default __webpack_public_path__ + "static/media/projects-tab-unselected-mobile.97e8fbf6.svg";
export { ForwardRef as ReactComponent };